import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";
export interface SupportService {
    id: number;
    name: string;
    status: number;
}
export const supportServiceApi = createApi({
    reducerPath: "supportServiceApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getSupportServices: builder.query<SupportService[], void>({
            query: () => '/support-service'
        }),
    })
})

export const { useGetSupportServicesQuery } = supportServiceApi;